import ResetPasswordConfirmForm from 'components/ResetPasswordConfirm/ResetPasswordConfirmForm'
import ResetPasswordConfirmProvider from 'components/ResetPasswordConfirm/ResetPasswordConfirmProvider'
import React from 'react'

const ResetPasswordConfirmPage = () => {
  return (
   <ResetPasswordConfirmProvider defaultValues={null}>
      <ResetPasswordConfirmForm />
   </ResetPasswordConfirmProvider>
    
  )
}

export default ResetPasswordConfirmPage